export default defineNuxtPlugin(() => {
  if (!['production', 'staging'].includes(process.env.NODE_ENV)) {
    return;
  }

  function loadScript() {
    window.removeEventListener('touchstart', loadScript);
    window.removeEventListener('mousemove', loadScript);
    window.removeEventListener('scroll', loadScript);

    (function (e, t, n, s, u, a) {
      if (e.twq) return;

      s = e.twq = function () {
        s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
      };
      s.version = '1.1';
      s.queue = [];
      u = t.createElement(n);
      u.async = !0;
      u.src = '//static.ads-twitter.com/uwt.js';
      a = t.getElementsByTagName(n)[0];
      a.parentNode.insertBefore(u, a);
    })(window, document, 'script');

    create();
  }

  function create() {
    window.twq('init', 'o6au7');
    window.twq('track', 'PageView');
    const router = useRouter();

    router.afterEach(() => {
      window.twq('track', 'PageView');
    });
  }

  window.addEventListener('touchstart', loadScript);
  window.addEventListener('mousemove', loadScript);
  window.addEventListener('scroll', loadScript);
});
